import { useGetUserSettingInfo } from "@/api/services/main/user-setting";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { UserSettingEditPage } from "@/features/user-setting/pages/UserSettingEdit";
import { convertResDtoToFormData } from "@/features/user-setting/utils/user-setting";

const UserSettingEdit = () => {
  const { data: userSettingResult, isLoading } = useGetUserSettingInfo();

  if (isLoading || !userSettingResult) return <LoadingPage />;
  return <UserSettingEditPage isCreating={!Boolean(userSettingResult.data?.id)} defaultValues={convertResDtoToFormData(userSettingResult?.data)} />;
};

export default UserSettingEdit;
